import axios from 'axios';
import {baseUrl} from '../config/CONSTANTS';

axios.defaults.baseURL = baseUrl;
// axios.defaults.withCredentials = true;

// axios.defaults.headers.common = {
// 	'X-Requested-With': 'XMLHttpRequest'
// };
//
// axios.defaults.headers.get = {
// 	"Accept": "application/json",
// 	"Content-Type": "application/json; charset=UTF-8"
// };
//
// axios.defaults.headers.post = {
// 	'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
// };
// axios.defaults.headers = {
// 	'X-Requested-With': 'XMLHttpRequest',
// 	"Accept": "application/json",
// 	"Content-Type": "application/json; charset=UTF-8"
// };

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	// 对响应数据做点什么
	// console.log('对响应数据做点什么', response)
	if(response.status === 200)
		return response.data;
	else
		return {}
}, function (error) {
	// 对响应错误做点什么
	return Promise.reject(error);
});

// console.log(axios.defaults)

export default axios;


// WEBPACK FOOTER //
// ./src/axios/index.js